import createPersistedState from 'vuex-persistedstate'

export const plugins = [
	createPersistedState({
		paths: ['settings', 'admin', 'local']
	})
]

export const strict = false